import Utils from "../../../../../shared/utils";

export const IMAGE_URL = Utils.buildProductPageImageLink("rent/safecheck/first-section.svg")

export const MAIN_TITLE_ICON = Utils.buildProductPageImageLink("icons/umbrella-icon.svg");
